import React, { useState, useEffect } from 'react';
import { Checkbox, Input, Space } from 'antd';

const AggregateContent = ({ aggregatedAttributes, setAggregatedAttributes, selectedMenu }) => {
  const attributes = [
    { label: 'Initiatives (#)', value: 'initiativeCount' },
    // Annualized planned impact
    {
      label: 'Net recurring benefits (planned, ETB Mn)',
      value: 'netRecurringBenefitsPlanned',
      group: 'Annualized Planned Impact',
    },
    {
      label: 'One Time Benefit (planned, ETB Mn)',
      value: 'oneTimeBenefitsPlanned',
      group: 'Annualized Planned Impact',
    },
    {
      label: 'Implementation costs (planned, ETB Mn)',
      value: 'implementationCostsPlanned',
      group: 'Annualized Planned Impact',
    },
    // Annualized Latest Estimate
    {
      label: 'Net recurring benefits (LE, ETB Mn)',
      value: 'netRecurringBenefitsLatest',
      group: 'Annualized Latest Estimate',
    },
    {
      label: 'One Time Benefit (LE, ETB Mn)',
      value: 'oneTimeBenefitsLatest',
      group: 'Annualized Latest Estimate',
    },
    {
      label: 'Implementation costs (LE, ETB Mn)',
      value: 'implementationCostsLatest',
      group: 'Annualized Latest Estimate',
    },
    // total calanderized impact
    {
      label: 'Planned impact (total, ETB Mn)',
      value: 'plannedImpactTotal',
      group: 'Total Calanderized Impacts',
    },
    {
      label: 'Actual impact (total, ETB Mn)',
      value: 'actualImpactTotal',
      group: 'Total Calanderized Impacts',
    },
    {
      label: 'Forecast impact (total, ETB Mn)',
      value: 'forecastImpactTotal',
      group: 'Total Calanderized Impacts',
    },
    {
      label: 'LE impact (total, ETB Mn)',
      value: 'leImpactTotal',
      group: 'Total Calanderized Impacts',
    },
    {
      label: 'Total impact (total, ETB mn',
      value: 'totalImpactTotal',
      group: 'Total Calanderized Impacts',
    },
    // total calanderized impact (excl. Cancelled, onhold, reject)
    {
      label: 'Planned impact (total, ETB Mn)',
      value: 'plannedImpactTotalExcl',
      group: 'Total Calanderized Impact(excl. Cancelled, On hold and Rejected)',
    },
    {
      label: 'Actual impact (total, ETB Mn)',
      value: 'actualImpactTotalExcl',
      group: 'Total Calanderized Impact(excl. Cancelled, On hold and Rejected)',
    },
    {
      label: 'Forecast impact (total, ETB Mn)',
      value: 'forecastImpactTotalExcl',
      group: 'Total Calanderized Impact(excl. Cancelled, On hold and Rejected)',
    },
    {
      label: 'LE impact (total, ETB Mn)',
      value: 'leImpactTotalExcl',
      group: 'Total Calanderized Impact(excl. Cancelled, On hold and Rejected)',
    },
    {
      label: 'Planned FTP Impact',
      value: 'plannedFTPValue',
      group: 'Total FTP Calanderized Impacts'
    },
    {
      label: 'Actual FTP Impact',
      value: 'actualFTPValue',
      group: 'Total FTP Calanderized Impacts'
    },
    {
      label: 'Total Planned KPI',
      value: 'plannedKPI',
      group: 'KPI'
    },
    {
      label: 'Total Planned Deposit KPI',
      value: 'plannedDepositKPI',
      group: 'KPI'
    },
    {
      label: 'Total Planned Loan KPI',
      value: 'plannedLoanKPI',
      group: 'KPI'
    },
    {
      label: 'Total Planned Financing KPI',
      value: 'plannedFinancingKPI',
      group: 'KPI'
    },
    {
      label: 'Total Planned FCY KPI',
      value: 'plannedFCYKPI',
      group: 'KPI'
    },
    {
      label: 'Total Actual KPI',
      value: 'actualKPI',
      group: 'KPI'
    },
    {
      label: 'Total Actual Deposit KPI',
      value: 'actualDepositKPI',
      group: 'KPI'
    },
    {
      label: 'Total Actual Loan KPI',
      value: 'actualLoanKPI',
      group: 'KPI'
    },
    {
      label: 'Total Actual Financing KPI',
      value: 'actualFinancingKPI',
      group: 'KPI'
    },
    {
      label: 'Total Actual FCY KPI',
      value: 'actualFCYKPI',
      group: 'KPI'
    },
    {
      label: 'Total Account Planned to Open',
      value: 'plannedAccount',
      group: 'KPI'
    },
    {
      label: 'Total Opened Account',
      value: 'actualAccount',
      group: 'KPI'
    },
    {
      label: 'Initiative Owners (#)',
      value: 'initiativeOwnerCount',
      group: 'Initiative cadence & Health'
    },
    {
      label: 'Initiative per owner (avg, #)',
      value: 'initiativesPerOwner',
      group: 'Initiative cadence & Health'
    },
    {
      label: 'Total L1-L5 net recurring benefits (LE, ETB Mn)',
      value: 'totalL1L5NetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'Total L1 net recurring benefits (LE, ETB Mn)',
      value: 'totalL1NetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'Total L2 net recurring benefits (LE, ETB Mn)',
      value: 'totalL2NetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'Total L3 net recurring benefits (LE, ETB Mn)',
      value: 'totalL3NetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'Total L4 net recurring benefits (LE, ETB Mn)',
      value: 'totalL4NetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'Total L5 net recurring benefits (LE, ETB Mn)',
      value: 'totalL5NetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'L0-L2 net recurring benefits (LE, ETB Mn)',
      value: 'totalL0L2NetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'L1+ net recurring benefits (LE, ETB Mn)',
      value: 'totalL1PlusNetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'L2+ net recurring benefits (LE, ETB Mn)',
      value: 'totalL2PlusNetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'L3+ net recurring benefits (LE, ETB Mn)',
      value: 'totalL3PlusNetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'L4+ net recurring benefits (LE, ETB Mn)',
      value: 'totalL4PlusNetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'L1+ vs target net recurring benefits (%)',
      value: 'totalL1+vsNetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'L2+ vs target net recurring benefits (%)',
      value: 'totalL2+vsNetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'L3+ vs target net recurring benefits (%)',
      value: 'totalL3+vsNetRecurringBenefit',
      group: 'Net recurring benefits by stage'
    },
    {
      label: 'Δ L1+ vs LW L1+ net recurring benefits (ETB Mn)',
      value: 'ΔL1+vsLWL1+netrecurringbenefits',
      group: 'LX+ weekly pipeline'
    },
    {
      label: '(LW) L1+ net recurring benefits (LE, ETB Mn)',
      value: '(LW)L1+netrecurringbenefits',
      group: '🗓️ Ref. net recurring benefits by stage'
    },
    {
      label: 'Milestones(#)',
      value: 'totalMilestone',
      group: 'Milestone cadence & Health'
    },
    {
      label: 'Milestone Owners(#)',
      value: 'totalMilestoneOwners',
      group: 'Milestone cadence & Health'
    },
    {
      label: 'Milestone per Owners(avg. #)',
      value: 'totalMilestonePerOwners',
      group: 'Milestone cadence & Health'
    },
    {
      label: 'Milestone Per Initiative(avg. #)',
      value: 'totalMilestonePerInitiative',
      group: 'Milestone cadence & Health'
    },
    {
      label: 'Late Milestones (#)',
      value: 'totalLateMilestone',
      group: 'Milestone cadence & Health'
    },
    {
      label: 'Propertion of late Milestones (%)',
      value: 'propertionOfLateMilestones',
      group: 'Milestone cadence & Health'
    },
    {
      label: 'Propertion of Completed Milestones (%)',
      value: 'completedMilestone',
      group: 'Milestone cadence & Health'
    },
    {
      label: 'Workstream Actions (#)',
      value: 'workstreamActionCount',
      group: 'Workstream action cadence and Health'
    },
    {
      label: 'Action Item Owners (#)',
      value: 'workstreamActionOwnerCount',
      group: 'Workstream action cadence and Health'
    },
    {
      label: 'Workstream Actions Per Owner (Avg)',
      value: 'averageWorkstreamActionPerOwner',
      group: 'Workstream action cadence and Health'
    },
    {
      label: 'Late Workstream Actions (#)',
      value: 'lateWorkstreamAction',
      group: 'Workstream action cadence and Health'
    },
    {
      label: 'Proportion of Late Workstream Actions (%)',
      // Corrected the typo from 'Ation' to 'Action'
      value: 'proportionOfLateWorkstreamActions',
      group: 'Workstream action cadence and Health'
    },
    {
      label: 'Proportion of Completed Workstream Actions (%)',
      // Corrected the typo from 'Ation' to 'Action'
      value: 'proportionOfCompletedWorkstreamActions',
      group: 'Workstream action cadence and Health'
    }
  ];
  const [searchQuery, setSearchQuery] = useState('');

  // // This useEffect handles the initial default for 'initiativeCount' and dynamic clearing.
  // useEffect(() => {
  //   if (selectedMenu.key === 'Table') { // Assuming selectedMenu is an object with a 'key'
  //     // If no attributes are currently selected, default to 'initiativeCount'
  //     if (aggregatedAttributes.length === 0) {
  //       setAggregatedAttributes(['initiativeCount']);
  //     }
  //     // If attributes are already selected, do nothing; let the user control them.
  //     // The initiativeCount will only be forced if the array is empty.
  //   } else {
  //     // If the menu is not 'Table', clear all aggregated attributes
  //     setAggregatedAttributes([]);
  //   }
  // }, [selectedMenu.key, aggregatedAttributes.length, setAggregatedAttributes]); // Depend on key and array length

  const filteredAttributes = attributes.filter((attribute) =>
    attribute.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const groupedAttributes = {};
  filteredAttributes.forEach((attr) => {
    if (attr.group) {
      if (!groupedAttributes[attr.group]) {
        groupedAttributes[attr.group] = [];
      }
      groupedAttributes[attr.group].push(attr);
    } else {
      if (!groupedAttributes['']) {
        groupedAttributes[''] = [];
      }
      groupedAttributes[''].push(attr);
    }
  });

  return (
    <div style={{ padding: '10px', maxHeight: '500px', overflowY: 'auto' }}>
      <Input
        placeholder="Search attributes..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{ marginBottom: '10px' }}
      />
      <Checkbox.Group
        value={aggregatedAttributes}
        onChange={(checkedValues) => {
          // This is the core logic for user interaction:
          // If the user unchecks everything, and 'initiativeCount' is currently selected,
          // then keep 'initiativeCount' selected. Otherwise, just update with checkedValues.
          if (checkedValues.length === 0 && aggregatedAttributes.includes('initiativeCount')) {
            setAggregatedAttributes(['initiativeCount']);
          } else {
            setAggregatedAttributes(checkedValues);
          }
        }}
      >
        {Object.entries(groupedAttributes).map(([groupName, attributesInGroup]) => (
          <div key={groupName}>
            {groupName && (
              <div style={{ fontWeight: 'bold', marginTop: '10px', fontSize: 14, color: '#333' }}>
                {groupName}
              </div>
            )}
            <Space direction="vertical">
              {attributesInGroup.map((attr) => (
                <div key={attr.value}>
                  <Checkbox value={attr.value}>
                    {attr.label}
                  </Checkbox>
                </div>
              ))}
            </Space>
          </div>
        ))}
      </Checkbox.Group>
    </div>
  );
};

export default AggregateContent;